import { render } from "./edit.vue?vue&type=template&id=bc8c4846"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/customer_products/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bc8c4846"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bc8c4846', __exports__)) {
    console.log('reload')
    api.reload('bc8c4846', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=bc8c4846", () => {
    console.log('re-render')
    api.rerender('bc8c4846', render)
  })

}


export default __exports__